module.exports = __webpack_public_path__ + "img/LogoCSA_Gris.62c9ad5b.png";